/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Default_View_DescInputs */



/**
* | output |
* | --- |
* | "The view your agenda opens in by default." |
*
* @param {Settings_Default_View_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_default_view_desc = /** @type {((inputs?: Settings_Default_View_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Default_View_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De weergave waarin je agenda standaard opent.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La vue dans laquelle votre agenda s'ouvre par défaut.")
	return /** @type {LocalizedString} */ ("The view your agenda opens in by default.")
});